import { Navigate, Outlet } from 'react-router-dom';
import { SignupDataProvider } from '@assetron/common/contexts/SignupDataContext';
import SignupStepWrapper from '../navigation/SignupStepWrapper';
import Loadable from '@assetron/web-common/components/common/Loadable';
import PublicRoutes from './wrappers/PublicRoutes';
import ResetPasswordStepWrapper from '../navigation/ResetPasswordStepWrapper';
import AcceptInvite from '../pages/invite/AcceptInvite';
import lazyWithErrorHandling from '@assetron/common/utils/lazyWithErrorHandling';
import { QueryParamPersistence } from '@assetron/web-common/utils/queryParamPersistence';

const Signin = Loadable(
  lazyWithErrorHandling(() => import('../pages/auth/signin/Signin')),
);

const AuthRoutes = (isAuthenticated: boolean) => ({
  path: '/',
  element: (
    <SignupDataProvider>
      <PublicRoutes isAuthenticated={isAuthenticated}>
        <Outlet />
      </PublicRoutes>
    </SignupDataProvider>
  ),
  children: [
    {
      index: true,
      element: <Navigate to={QueryParamPersistence.addPersistedParamsToPath("/sign-in")} replace />,
    },
    {
      path: 'sign-up',
      element: <SignupStepWrapper />, // Handles the other signup steps via state
    },
    {
      path: 'sign-in',
      element: <Signin />,
    },
    {
      path: 'reset-password',
      element: <ResetPasswordStepWrapper />,
    },
    {
      path: 'invite/accept',
      element: <AcceptInvite />,
    },
  ],
});

export default AuthRoutes;
